import { styled } from '@mui/material/styles';

// @ts-ignore
export const CalendarContainer = styled('div')(({ theme, isMediumSize }) => ({
  '& .fc-license-message': {
    display: 'none',
  },
  '& .fc': {
    '--fc-bg-event-opacity': 1,
    '--fc-border-color': theme.palette.divider,
    '--fc-daygrid-event-dot-width': '10px',
    '--fc-event-border-color': 'none',
    '--fc-event-text-color': theme.palette.primary.contrastText,
    '--fc-list-event-hover-bg-color': theme.palette.background.default,
    '--fc-neutral-bg-color': theme.palette.background.default,
    '--fc-page-bg-color': theme.palette.background.default,
    '--fc-today-bg-color': '#EBEEFE',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    '& .fc-daygrid-event': {
      position: 'absolute',
      top: '0',
      backgroundColor: 'rgba(56, 66, 80, 0.04)',
      marginTop: '-35px',
      marginLeft: isMediumSize ? '-22px' : '-15px',
    },
    '& .fc-event': {
      backgroundColor: 'transparent',
      zIndex: 0,
    },
  },
  '& .fc .fc-col-header-cell-cushion': {
    padding: '0px',
    // paddingBottom: '10px',
    // paddingTop: '10px',
    fontSize: theme.typography.overline.fontSize,
    fontWeight: theme.typography.overline.fontWeight,
    letterSpacing: theme.typography.overline.letterSpacing,
    lineHeight: theme.typography.overline.lineHeight,
    textTransform: theme.typography.overline.textTransform,
    color: '#6C737F',
  },
  '& .fc .fc-day-other .fc-daygrid-day-top': {
    color: theme.palette.text.secondary,
    height: '100%',
  },
  '& .fc-daygrid-event': {
    borderRadius: theme.shape.borderRadius,
    padding: '0px 4px',
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.subtitle2.fontWeight,
    lineHeight: theme.typography.subtitle2.lineHeight,
  },
  '& .fc-daygrid-block-event .fc-event-time': {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    lineHeight: theme.typography.body2.lineHeight,
  },
  '& .fc-daygrid-day-frame': {
    padding: '12px',
    height: '127px',
  },
  '& .fc-scrollgrid': {
    borderColor: 'transparent',
  },
  '& .fc-scrollgrid td:last-of-type': {
    borderRightColor: 'transparent',
  },
  '& .fc-scrollgrid-section.fc-scrollgrid-section-body td[role="presentation"]': {
    borderBottomColor: 'transparent',
  },
  '& [role="row"]:last-of-type td': {
    borderBottomColor: 'transparent',
  },
  '& th[role="presentation"]': {
    borderRightColor: 'transparent',
  },
  '& .fc-list': {
    borderColor: 'transparent',
  },
  '& .fc-scrollgrid-section-body': {
    height: 'auto',
  },
  '& .fc-scroller': {
    overflowY: 'hidden !important',
  },
  '& .fc-day-sun': {
    // backgroundColor: 'rgba(0, 0, 0, 0.04)',
    border: '1px solid #E5E7EB',
  },
  '& .fc-day': {
    border: '1px solid #E5E7EB',
    padding: '10px',
  },
}));
